import { Component } from '@angular/core';
import { fadeInAnimation } from '../../../animations';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { BaseContainer } from 'app/modules/base/BaseContainer';
import { CustomerInfo } from 'app/core/store/customer-info/customer-info.interface';
import { StockCountFilter } from 'app/core/store/stock-count/stock-count-filter.interface';
import moment from 'moment';
import { appSettings } from 'app/appSettings';
import { StockCountDetail, StockCountItem, StockCountState } from 'app/core/store/stock-count/stock-count.interface';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { SessionState } from 'app/core/store/session/session.interface';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-stock-count-page',
  templateUrl: './stock-count-page.container.html',
  styleUrls: ['../../florders/florder-page-container/florder-page.container.scss', './stock-count-page.container.scss'],
  animations: [fadeInAnimation],
})
export class StockCountPageContainer extends BaseContainer {
  filter: StockCountFilter = {};
  twoWeeksAgo = moment();
  twoWeeksAgoString: string;
  stockCountsItems: StockCountItem[];
  totalItems: number = 0;
  shipTos: Definition[];

  stockCount: StockCountDetail = null;
  authMatrix: AuthorizationMatrix;

  constructor(public sandbox: StockCountSandbox) {
    super();
    this.sandbox.resetCreate();

    this.twoWeeksAgo.subtract(2, 'weeks');
    this.twoWeeksAgoString = this.twoWeeksAgo.format(appSettings.DATE_FORMAT_MOMENT_REST);
    this.filter.countDateFrom = this.twoWeeksAgoString;

    this.store
      .select('customerInfo')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((customerInfo: CustomerInfo) => ({
          shipTos: customerInfo.customer ? customerInfo.customer.shipTos : null,
          customerNr: customerInfo.customer ? customerInfo.customer.id : null,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ shipTos, customerNr }) => {
        if (shipTos && customerNr) {
          this.sandbox.getShipTos(customerNr);
        }
      });

    this.store
      .select('stockCount')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((stockCount: StockCountState) => {
          return {
            stockCounts: stockCount.stockCounts,
            filter: stockCount.filter,
            detail: stockCount.detail,
            shipTos: stockCount.shipTos.data,
          };
        }),
        distinctUntilChanged()
      )
      .subscribe(({ stockCounts, filter, detail, shipTos }) => {
        this.stockCountsItems = stockCounts.data?.items || this.stockCountsItems;
        this.totalItems = stockCounts.data?.totalItems || this.totalItems;
        this.filter = filter ? { ...this.filter, ...filter } : this.filter;
        this.stockCount = detail ? detail.data : this.stockCount;
        this.shipTos = shipTos ? shipTos : this.shipTos;
      });

    this.store
      .select('session')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((session: SessionState) => {
          return {
            auth: session.authorization.data,
          };
        }),
        distinctUntilChanged()
      )
      .subscribe(({ auth }) => {
        this.authMatrix = auth;
      });
  }

  createStockCount() {
    // choose shipto
    this.sandbox.goToCreate();
  }

  filterStockCounts(filter: { value: StockCountFilter; valid: boolean }) {
    const defaultPageSizeAndNumberFilter = {
      ...filter,
      value: {
        ...filter.value,
        pageSize: 25,
        pageNumber: 1,
      },
    };
    this.sandbox.filterStockCounts(defaultPageSizeAndNumberFilter);
  }

  goToPrint() {
    this.sandbox.print();
  }
}
